import { useEffect } from "react"

export default function SecurityCodeFocus() {
  useEffect(() => {
    $(".security-code-input").focus()
  }, [])

  return null
}
